import { Button, IconButton, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow } from '@mui/material';
import axios from '../../util/Axios';
import { useEffect, useState } from 'react';
import { Page } from '../../components/Page';
import DeleteIcon from '@mui/icons-material/Delete';
import { ConfirmDelete } from '../../components/ConfirmDelete';
import { Invitation } from './Invitation';

export function Invitations({ trigerRefresh }) {
  const [openInvitation, setOpenInvitation] = useState(false);

  const [invitations, setInvtiations] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [pageParam, setPageParam] = useState(0);
  const [shouldRefresh, setShouldRefresh] = useState(false);

  const [page, setPage] = useState({ number: 0, count: 0 });

  const [selectedInvitation, setSelectedInvitation] = useState({});
  const [openDelete, setOpenDelete] = useState(false);

  useEffect(() => {
    axios.get(`/invitations/?size=${rowsPerPage}&page=${pageParam}`).then((response) => {
      setInvtiations(response.data.content);
      setPage({ number: response.data.number, count: response.data.totalElements });
      setShouldRefresh(false);
    });
  }, [shouldRefresh, rowsPerPage, pageParam]);

  useEffect(() => {
    if (trigerRefresh) {
      setShouldRefresh(true);
    }
  }, [trigerRefresh]);

  const onConfirmDelete = (invitation) => {
    setSelectedInvitation(invitation);
    setOpenDelete(true);
  };

  const onCancelDelete = () => {
    setSelectedInvitation({});
    setOpenDelete(false);
  };

  const deleteInvitation = () => {
    setOpenDelete(false);
    axios(`invitations/${selectedInvitation.id}`, {
      method: 'DELETE',
    }).then((resp) => {
      setOpenDelete(false);
      setShouldRefresh(true);
    });
  };

  const handleInvitationClose = () => {
    setOpenInvitation(false);
    setShouldRefresh(true);
  };

  return (
    <Page>
      <Button variant="contained" color="secondary" onClick={() => setOpenInvitation(true)}>
        Invite
      </Button>
      <Table size="small" aria-label="users">
        <TableHead>
          <TableRow key="1">
            <TableCell>Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Hospital</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Country</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {invitations.map((invitation) => (
            <TableRow key={invitation.id}>
              <TableCell>{invitation.fullName}</TableCell>
              <TableCell>{invitation.email}</TableCell>
              <TableCell>{invitation.hospital}</TableCell>
              <TableCell>{invitation.status || 'Pending'}</TableCell>
              <TableCell>{invitation.country}</TableCell>
              <TableCell>
                <IconButton aria-label="delete" onClick={() => onConfirmDelete(invitation)}>
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination rowsPerPageOptions={[5, 10, 20, 50, 100, 1000]} rowsPerPage={rowsPerPage} onRowsPerPageChange={(e) => setRowsPerPage(e.target.value)} count={page.count} page={page.number} onPageChange={(e, newPage) => setPageParam(newPage)} />
          </TableRow>
        </TableFooter>
      </Table>
      <ConfirmDelete open={openDelete} handleClose={onCancelDelete} handleDelete={deleteInvitation} label={'invitation for ' + selectedInvitation?.fullName} />
      <Invitation open={openInvitation} onClose={handleInvitationClose} />
    </Page>
  );
}
